import { useDisclosure } from '@mantine/hooks'
import React, { useEffect, useRef, useState } from 'react'
import { Button, Col, Form, OverlayTrigger, Tooltip } from 'react-bootstrap'
import { useForm } from 'react-hook-form'
import { useQuery } from 'react-query'
import { useDispatch } from 'react-redux'
import { useHistory } from 'react-router-dom'

import ColetaClickstream from '../../../../components/clickstreamAnalise/clickstreamColeta.js'
import { api_gateway } from '../../../../conexoes/api'
import '../../../../css/painelSms/smsMensagens/enviarSms/enviarSms.css'
import { revelarEnviarSmsModulo } from '../../../../redux/actions/index'
import { useGlobal } from '../../../../stores/useGlobal'
import {
  elipseVerde,
  exclamacao,
  fecharJanela,
  setaDropdown
} from '../../../../utils/alternanciaIcones'
import decryptJWT from '../../../../utils/decryptJWT'
import utilsSms from '../../../../utils/sms'
import { validatePhones } from '../../../../utils/validarTelefones'
import MensagemAtencao from '../../../componentesModais/mensagens/mensagemAtencao.js'
import MensagemErro from '../../../componentesModais/mensagens/mensagemErro'
import MensagemSucesso from '../../../componentesModais/mensagens/mensagemSucesso'
import SelectTemplateSms from '../../../componentesModais/selects/selectTemplateSms'
import SpinerVeye from '../../../spinnerVeye/spinnerVeye.js'
import { logout } from '../../../../services/auth'
import Alerta from '../Alerta'

const MENSAGENS = {
  naoPossuiContaSms: {
    titulo: 'Atenção',
    mensagem:
      'Não é possível enviar mensagens pois seu usuário não possui conta SMS ativa.'
  },
  somenteNeoClaro: {
    titulo: 'Atenção',
    mensagem:
      'Só é possível enviar mensagens para linhas NEO Claro pois seu usuário não possui conta SMS ativa.'
  }
}

const CODIGOS_OPERADORA_NEO_CLARO = '89,93,95'

const iconeAlerta = (
  <img className="icone-alerta" src={exclamacao()} alt="exclamacao" />
)

export default function EnviarSms(props) {
  const [spinAtivo, setSpinAtivo] = useState(false)
  const history = useHistory()
  const { setIsLoadingGlobal } = useGlobal()
  const [invalidSimcards, setInvalidSimcards] = useState([])
  const [openedAlerta, { open: openAlerta, close: closeAlerta }] =
    useDisclosure(false)
  const { register, handleSubmit, errors } = useForm()
  const [dsCallerIds, setCallerIds] = useState('')
  const [dsMensagem, setDsMensagem] = useState('')
  const [dsTemplateSms, setDsTemplateSms] = useState('Selecione')
  const [saldoDisponivel, setSaldoDisponivel] = useState(0)
  const [creditosNecessarios, setCreditosNecessarios] = useState(0)
  const [caracteresMensagem, setCaracteresMensagem] = useState(120)
  const [revelarSelectTemplateSms, setRevelarSelectTemplateSms] =
    useState(false)
  const [revelarMensagemSucesso, setRevelarMensagemSucesso] = useState(false)
  const [revelarMensagemErro, setRevelarMensagemErro] = useState(false)
  const [limiteExcedido, setLimiteExcedido] = useState(false)
  const [mensagemErro, setMensagemErro] = useState(
    'Ocorreu um erro ao executar esta ação'
  )
  const [mensagemAtencao, setMensagemAtencao] = useState(null)
  const [carregandoValidacao, setCarregandoValidacao] = useState(true)

  const cdSmsContaUsuario = utilsSms.getCdSmsContaUsuario()
  const disabledConfirmar = dsCallerIds.length === 0 || !dsMensagem
  const userHasSMS = decryptJWT('userHasSMS')

  const despacho = useDispatch()
  const modal = useRef()

  const { data: dataNeoClaro, isFetching: isSuccessNeoClaro } = useQuery(
    'validarSimcardsNeoClaro',
    async () => {
      const params = {
        busca: '',
        ordenador: '',
        filtro: JSON.stringify({ OPERADORA: CODIGOS_OPERADORA_NEO_CLARO }),
        contar: true,
        buscaArquivo: JSON.stringify({})
      }

      const response = await api_gateway.get('/api/v2/devices/simcard', {
        params
      })

      return response.data?.devices?.length || 0
    },
    {
      enabled: !userHasSMS,
      keepPreviousData: false,
      refetchOnWindowFocus: false
    }
  )

  useQuery(
    'carregarSaldoSms',
    async () => {
      const query = utilsSms.getNewQueryGet('paginaAtual=0&carregarLimit=1')
      const response = await api_gateway.get(
        `/m1/consultar/smsExtrato?${query}`
      )

      if (
        response.data.status === 200 &&
        response.data.dados[0] !== undefined
      ) {
        return response.data.dados[0].n0_saldo_real
      } else {
        return 0
      }
    },
    {
      onSuccess: (saldo) => {
        setSaldoDisponivel(saldo)
      },
      keepPreviousData: false,
      refetchOnWindowFocus: false
    }
  )

  useEffect(() => {
    if (!userHasSMS && !isSuccessNeoClaro) {
      const quantidade = dataNeoClaro

      if (quantidade > 1) {
        setMensagemAtencao(MENSAGENS.somenteNeoClaro)
      } else {
        setMensagemAtencao(MENSAGENS.naoPossuiContaSms)
      }

      setCarregandoValidacao(false)
    } else if (userHasSMS) {
      setCarregandoValidacao(false)
    }
  }, [userHasSMS, isSuccessNeoClaro])

  const handleCreditosGastos = async () => {
    const validPhones = validatePhones(dsCallerIds)
    setCallerIds(validPhones)

    if (validPhones && validPhones !== '') {
      setIsLoadingGlobal(true)
      try {
        const response = await api_gateway.post('/m1/consultar/validadorSms', {
          lista_callerIds: validPhones.split(';')
        })

        if (response.data.status === 200) {
          setCreditosNecessarios(response.data.neededCredits)
        } else {
          setCreditosNecessarios(0)
        }
      } catch (err) {
        console.error(err)
        setCreditosNecessarios(0)
      } finally {
        setIsLoadingGlobal(false)
      }
    } else {
      setCreditosNecessarios(0)
    }
  }

  async function handleEnviar() {
    ColetaClickstream(1205) /*dropAcoesRevelarEnviarSmsModuloConfirmar*/
    setSpinAtivo(true)
    /*
        validação feita para avisar o usuário que só é possível caractéres alfa númericos,
        sem caractéres especiais tais quais +55(51)99999-5555
      */
    let arrayCallerIds = dsCallerIds.split(';')
    // eslint-disable-next-line no-useless-escape
    let regex = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+/
    let arrayRegex = arrayCallerIds.map((callerId) => {
      if (regex.test(callerId)) {
        return true
      } else {
        return false
      }
    })

    if (arrayRegex.includes(true)) {
      setMensagemErro('Utilize somente caracteres alfanuméricos.')
      setRevelarMensagemErro(true)
      setSpinAtivo(false)
    } else {
      const bodyEnviarSms = utilsSms.getNewBodyPost({
        lista_callerIds: arrayCallerIds,
        ds_mensagem: dsMensagem,
        cd_sms_tipo: 2
      })

      await api_gateway
        .post('/m1/cadastrar/smsEnvio', bodyEnviarSms)
        .then(function () {
          setRevelarMensagemSucesso(true)
        })
        .catch(function (error) {
          if (error.response.data.info === 'Excedeu o limite de envios!') {
            setLimiteExcedido(true)
            setMensagemErro(
              'Seu acesso foi bloqueado por exceder o limite mensal de envios de SMS. Entre em contato com o suporte técnico para mais informações.'
            )

            openAlerta()
            return
          }
          const invalidSimcards = error.response?.data?.invalidSimcards

          if (invalidSimcards?.length > 0) {
            const invalidNumbers = invalidSimcards.map((num) =>
              num.startsWith('55') ? num.slice(2) : num
            )

            const filteredCallerIds = arrayCallerIds.filter(
              (id) => !invalidNumbers.includes(id)
            )

            const callerIdsString = filteredCallerIds.join(';')

            setCallerIds(callerIdsString)
            setInvalidSimcards(invalidSimcards)
          }

          setMensagemErro(error.response?.data?.message)

          openAlerta()
        })
        .finally(() => {
          setSpinAtivo(false)
        })
    }
  }

  function handleCancelar() {
    ColetaClickstream(1204) /*dropAcoesRevelarEnviarSmsModuloCancelar*/
    despacho(revelarEnviarSmsModulo(false))
  }

  function handleMensagemErro() {
    if (revelarMensagemErro === false) setRevelarMensagemErro(true)
    else setRevelarMensagemErro(false)
  }

  function handleMensagemSucesso() {
    if (revelarMensagemSucesso === false) setRevelarMensagemSucesso(true)
    else {
      setRevelarMensagemSucesso(false)
      handleCancelar()
      props.setRenderizar(!props.renderizar)
    }
  }

  function handleMotivo(motivo) {
    setDsMensagem(motivo)
    setCaracteresMensagem(120 - motivo.length)
  }

  const handleCloseAlert = () => {
    closeAlerta()

    if (limiteExcedido) {
      logout()
      history.push('/login')
    } else if (
      mensagemErro.includes('todas as linhas inseridas foram removidas')
    ) {
      handleCancelar()
    }
  }

  if (carregandoValidacao) return null

  if (mensagemAtencao) {
    const handleFechar = () => {
      if (mensagemAtencao === MENSAGENS.naoPossuiContaSms) {
        handleCancelar()
      } else {
        setMensagemAtencao(null)
      }
    }

    return (
      <div className="componente-modal-overlay">
        <div className="componente-modal">
          <MensagemAtencao
            handleMensagemAtencao={handleFechar}
            mensagemTitulo={mensagemAtencao.titulo}
            mensagemParagrafo1={mensagemAtencao.mensagem}
            mensagemBotao="Fechar"
            semBotaoCancelar
          />
        </div>
      </div>
    )
  }

  return (
    <Form ref={modal} onSubmit={handleSubmit(() => handleEnviar())}>
      {spinAtivo && (
        <div className="componente-spinner-overlay">
          <div className="componente-spinner-container">
            <SpinerVeye />
          </div>
        </div>
      )}
      <div className="modal-envio-sms fundo-cor-6">
        <Form.Row>
          <Col>
            <img
              className="icone-label-janela"
              src={elipseVerde()}
              alt="elipse"
            />
            <Form.Label>
              <div className="fonte-cor-1 label-janela">Enviar</div>
            </Form.Label>
            <Button
              className="botao-fechar-janela"
              variant="danger"
              onClick={() => handleCancelar()}
            >
              <img
                className="botao-fechar-janela-icone"
                src={fecharJanela()}
                alt="fechar-janela"
              />
            </Button>
          </Col>
        </Form.Row>
        <Form.Row>
          <Col>
            <Form.Group>
              <Form.Label>
                <div className="fonte-cor-1 label-campo">Linhas</div>
              </Form.Label>
              <OverlayTrigger
                delay={{ show: 500, hide: 250 }}
                placement="bottom"
                overlay={
                  <Tooltip id="tooltip-bottom">Insira as linhas</Tooltip>
                }
              >
                <Form.Control
                  name="dsCallerIds"
                  value={dsCallerIds}
                  className="campo-texto-cor-3 campo-texto-area"
                  as="textarea"
                  placeholder="Insira as linhas separadas por ; | Não é necessário colocar o 55 (DDI) do Brasil | Utilize somente caracteres alfanuméricos"
                  rows="2"
                  maxLength="500"
                  onChange={(e) => setCallerIds(e.target.value)}
                  onBlur={() => handleCreditosGastos()}
                />
              </OverlayTrigger>
              {errors.dsCallerIds && (
                <p className="texto-campo-obrigatorio">
                  {iconeAlerta} O campo é obrigatorio.
                </p>
              )}
            </Form.Group>
          </Col>
        </Form.Row>
        <Form.Row>
          <Col>
            <div className="grupo-painel-sms-enviar-sms-1">
              <div className="coluna-painel-sms-enviar-sms-2">
                <Form.Label>
                  <div className="fonte-cor-1 label-campo">Template </div>
                </Form.Label>
                {revelarSelectTemplateSms === false && (
                  <Button
                    name="cdTemplateSms"
                    className="campo-texto-cor-3 campo-select"
                    onClick={() =>
                      setRevelarSelectTemplateSms(!revelarSelectTemplateSms)
                    }
                  >
                    <div className="fonte-cor-1 label-campo">
                      {dsTemplateSms}
                    </div>
                    <img
                      className={
                        revelarSelectTemplateSms
                          ? 'campo-select-icone-ativado nao-selecionavel'
                          : 'campo-select-icone-desativado nao-selecionavel'
                      }
                      src={setaDropdown()}
                      alt="drop"
                    />
                  </Button>
                )}
                {revelarSelectTemplateSms === true && (
                  <SelectTemplateSms
                    setRevelarSelectTemplateSms={setRevelarSelectTemplateSms} //Hook para fechar a modal
                    setDsMensagem={setDsMensagem}
                    setDsTemplateSms={setDsTemplateSms}
                    dsTemplateSms={dsTemplateSms}
                    cd_sms_conta_usuario={cdSmsContaUsuario}
                  />
                )}
              </div>
              <div className="coluna-painel-sms-enviar-sms-3">
                <div className="grupo-painel-sms-enviar-sms-2">
                  <div>
                    <span className="label-valor-cancelamento-reposicao-1 fonte-cor-1 negrito">
                      Créditos necessários:{' '}
                    </span>
                    <span className="label-valor-cancelamento-reposicao-2 fonte-cor-3 negrito">
                      {creditosNecessarios}
                    </span>
                  </div>
                  <div>
                    <span className="label-valor-cancelamento-reposicao-1 fonte-cor-1 negrito">
                      Créditos disponíveis:{' '}
                    </span>
                    <span className="label-valor-cancelamento-reposicao-2 fonte-cor-2 negrito">
                      {saldoDisponivel}{' '}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </Col>
        </Form.Row>
        <Form.Row>
          <Col>
            <Form.Group>
              <Form.Label>
                <div className="fonte-cor-1 label-campo">Mensagem</div>
              </Form.Label>
              <OverlayTrigger
                delay={{ show: 500, hide: 250 }}
                placement="bottom"
                overlay={
                  <Tooltip id="tooltip-bottom">Digite sua mensagem</Tooltip>
                }
              >
                <Form.Control
                  name="dsMensagem"
                  value={dsMensagem}
                  className="campo-texto-cor-3 campo-texto-area"
                  as="textarea"
                  placeholder="Digite sua mensagem"
                  rows="3"
                  onChange={(e) => handleMotivo(e.target.value)}
                  ref={register({ required: true })}
                  maxLength="120"
                />
              </OverlayTrigger>
              {errors.titulo && (
                <p className="texto-campo-obrigatorio">
                  {iconeAlerta} O campo é obrigatorio.
                </p>
              )}
              <Form.Label className="contador-carateres-restantes">
                <div className="fonte-cor-1 label-normal">
                  {caracteresMensagem} caracteres restantes
                </div>
              </Form.Label>
            </Form.Group>
          </Col>
        </Form.Row>
        <Form.Row>
          <Col>
            <Button
              disabled={disabledConfirmar}
              type="submit"
              className={
                disabledConfirmar
                  ? 'botao-confirmar-desabilitado'
                  : 'botao-confirmar'
              }
              variant="success"
              size="sm"
              onKeyPress={(e) => {
                e.key === 'Enter' && e.preventDefault()
              }}
            >
              <div className="fonte-cor-4">Confirmar</div>
            </Button>
            <Button
              className="botao-cancelar"
              variant="success"
              size="sm"
              onClick={() => handleCancelar()}
            >
              <div className="fonte-cor-2">Cancelar</div>
            </Button>
          </Col>
        </Form.Row>
      </div>
      {revelarMensagemSucesso && (
        <div className="componente-modal-overlay">
          <div className="componente-modal">
            <MensagemSucesso
              handleMensagemSucesso={handleMensagemSucesso}
              mensagemTitulo="Sucesso"
              mensagemParagrafo1="SMS Enviado."
              mensagemBotao="Continuar"
            />
          </div>
        </div>
      )}
      {revelarMensagemErro && (
        <div className="componente-modal-overlay">
          <div className="componente-modal">
            <MensagemErro
              handleMensagemErro={handleMensagemErro}
              mensagemTitulo="Erro!"
              mensagemParagrafo1={mensagemErro}
              mensagemBotao="Retornar"
            />
          </div>
        </div>
      )}
      {openedAlerta && (
        <Alerta
          opened={openedAlerta}
          onClick={handleCloseAlert}
          message={mensagemErro}
          invalidSimcards={invalidSimcards}
        />
      )}
    </Form>
  )
}
